if (!customElements.get("collections-showcase")) {
  class CollectionsShowcase extends HTMLElement {
    constructor() {
      super();

      this.selectors = {
        titles: [".collections-showcase__title"],
        contents: [".collections-showcase__content"],
      };

      this.classes = {
        isActive: "is-active",
      };

      this.elements = queryDomNodes(this.selectors, this);

      this.currentIndex = 0;
      this.hoverTracker = null;
    }

    connectedCallback() {
      if (this.elements.titles) {
        this.elements.titles.forEach((item) => {
          item.addEventListener("click", this.onClick.bind(this));
          item.addEventListener("mouseover", this.onMouseOver.bind(this));
          item.addEventListener("focus", this.onMouseOver.bind(this));
          item.addEventListener("keydown", this.onKeyDown.bind(this));
        });
      }

      if (Shopify.designMode) {
        document.addEventListener("shopify:block:select", (event) => {
          if (event.detail.sectionId != this.dataset.sectionId) return;
          const { target } = event;
          const index = Number(target.dataset.index);
          this.setActiveTab(index);
        });
      }
    }

    isSelected(el) {
      return el.classList.contains(this.classes.isActive);
    }

    onMouseOver(event) {
      const target = event.currentTarget;
      const index = Number(target.dataset.index);

      clearTimeout(this.hoverTracker);
      this.hoverTracker = setTimeout(() => {
        if (target.classList.contains(this.classes.isActive)) return;

        this.setActiveTab(index);
      }, 100);
    }

    onClick(event) {
      const target = event.currentTarget;
      const index = Number(target.dataset.index);

      if ("ontouchstart" in window) {
        if (target.classList.contains(this.classes.isActive)) return;
        this.setActiveTab(index);
      } else {
        const url = target.dataset.url;
        if (url) {
          window.location.href = url;
        }
      }
    }

    onKeyDown(event) {
      const index = Number(event.currentTarget.dataset.index);
      const totalTabs = this.elements.titles.length;
      let nextIndex = index;

      switch (event.key) {
        case "ArrowRight":
        case "ArrowDown":
          event.preventDefault();
          nextIndex = (index + 1) % totalTabs;
          this.setActiveTab(nextIndex);
          this.elements.titles[nextIndex].focus(); 
          break;
        case "ArrowLeft":
        case "ArrowUp":
          event.preventDefault();
          nextIndex = (index - 1 + totalTabs) % totalTabs;
          this.setActiveTab(nextIndex);
          this.elements.titles[nextIndex].focus(); 
          break;
        case "Enter":
        case " ":
          event.preventDefault();
          const url = event.currentTarget.dataset.url;
          if (url && !("ontouchstart" in window)) {
            window.location.href = url;
          } else {
            this.setActiveTab(index);
          }
          break;
      }
    }

    setActiveTab(newIndex) {
      if (this.currentIndex == newIndex) {
        return;
      }

      const newTitle = this.elements.titles[newIndex];
      const newContent = this.elements.contents[newIndex];

      this.elements.titles.forEach((el) => {
        const isSelected = el === newTitle;
        el.setAttribute("aria-selected", isSelected);
        el.setAttribute("tabindex", isSelected ? "0" : "-1");
        el.classList.remove(this.classes.isActive);
      });

      this.elements.contents.forEach((el) => {
        el.hidden = el !== newContent;
        el.classList.remove(this.classes.isActive);
      });

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          newTitle.classList.add(this.classes.isActive);
          newContent.classList.add(this.classes.isActive);
        });
      });

      this.currentIndex = newIndex;
    }

    disconnectedCallback() {}
  }
  customElements.define("collections-showcase", CollectionsShowcase);
}
